/**
 * Represents the camera or gesture effects a policy can ask the viewport search core to perform.
 */
export default class ViewportSearchIntentType {

  /**
   * It represents centering the map on a latitude and longitude.
   */
  static get Recenter() {
    return this.getInstance('recenter');
  }

  /**
   * It represents setting the map zoom.
   */
  static get SetZoom() {
    return this.getInstance('setZoom');
  }

  /**
   * It represents fitting the map to the given bounds.
   */
  static get FitBounds() {
    return this.getInstance('fitBounds');
  }

  /**
   * It represents treating the next settled position as user-driven.
   */
  static get GrantGesture() {
    return this.getInstance('grantGesture');
  }

  /**
   * It represents running a list of intents on the next map idle.
   */
  static get DeferUntilIdle() {
    return this.getInstance('deferUntilIdle');
  }

  /**
   * It represents applying a decision outside a settled position.
   */
  static get DispatchDecision() {
    return this.getInstance('dispatchDecision');
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new ViewportSearchIntentType(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(ViewportSearchIntentType, 'instances', { value: {} });
